import jwtDecode from 'jwt-decode';
import axios from 'axios';

class AuthService {
  handleAuthentication() {
    const accessToken = this.getAccessToken();

    if (!accessToken) {
      return;
    }

    if (this.isValidToken(accessToken)) {
      this.setSession(accessToken);
    } else {
      this.setSession(null);
    }
  }

  loginRails = (email: any, password: any) =>
    new Promise((resolve, reject) => {
      let body = {
        user: {
          email: email,
          password: password
        }
      };
      axios
        .post('/users/sign_in.json', body, { withCredentials: true })
        .then(response => {
          if (response.data) {
            this.setSession(response.data.accessToken);
            resolve(response.data.user);
          } else {
            reject(response.data.error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });

  adminLoginRails = (values: any) =>
    new Promise((resolve, reject) => {
      let body = {
        user: values
      };
      axios
        .post('/users/admin_sign_in.json', body, { withCredentials: true })
        .then(response => {
          if (response.data) {
            this.setSession(response.data.accessToken);
            resolve(response.data.user);
          } else {
            reject(response.data.error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });

  recoverPassword = (email: any) =>
    new Promise((resolve, reject) => {
      let body = {
        user: {
          email: email
        }
      };
      axios
        .post('/users/password', body, { withCredentials: true })
        .then(response => {
          if (response.data.status) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });

  EditPassword = (password: any, passwordConfirmation: any, token: any) =>
    new Promise((resolve, reject) => {
      let body = {
        user: {
          password: password,
          password_confirmation: passwordConfirmation,
          reset_password_token: token
        }
      };
      axios
        .put('/users/password', body, { withCredentials: true })
        .then(response => {
          if (response.data.status) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });

  loginInWithToken = async () => {
    let checkNode = new Promise((resolve, reject) => {
      let url = process.env.REACT_APP_API_URL;
      axios
        .get(url + '/users/checkAuth')
        .then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
    let checkRuby = new Promise((resolve, reject) => {
      axios
        .get('/new_autored/check_auth')
        .then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });

    try {
      const values = await Promise.all([checkNode, checkRuby]);
      return values[0];
    } catch (e) {
      this.logout();
    }
  };

  logout = async () => {
    let logoutRails = new Promise((resolve, reject) => {
      axios
        .delete('/users/sign_out.json', { withCredentials: true })
        .then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data.error);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
    try {
      await Promise.all([logoutRails]);
      this.setSession(null);
    } catch (err) {}
  };
  setSession = (accessToken: any) => {
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    } else {
      localStorage.removeItem('accessToken');
      delete axios.defaults.headers.common.Authorization;
    }
  };

  getAccessToken = () => localStorage.getItem('accessToken');

  isValidToken = (accessToken: any) => {
    if (!accessToken) {
      return false;
    }

    const decoded: any = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  };

  isAuthenticated = () => !!this.getAccessToken();

  deactivateFeature = (feature: any, data: any) =>
    new Promise((resolve, reject) => {
      let url = process.env.REACT_APP_API_URL;
      axios
        .post(url + '/desactivate_feature', { feature, data })
        .then((response: any) => {
          if (response.error) {
            reject(response.error);
          } else {
            resolve(response.message);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
}

const authService = new AuthService();

export default authService;
